import ReferenceHeader from "@/components/ReferenceHeader";
import AppFooter from "@/components/AppFooter";

export default function ReferenceLayout({ children }) {
  return (
    <div style={{ background: "var(--pord-bg, #222518)", minHeight: "100vh", color: "var(--pord-text, #fff)" }}>
      <ReferenceHeader />
      {children}
      <AppFooter />
    </div>
  );
}
